export const InstagramIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20Z"
            fill="white"
        />
        <path
            d="M21.5 3.5H10.5C8.64348 3.5 6.86301 4.2375 5.55025 5.55025C4.2375 6.86301 3.5 8.64348 3.5 10.5V21.5C3.5 23.3565 4.2375 25.137 5.55025 26.4497C6.86301 27.7625 8.64348 28.5 10.5 28.5H21.5C23.3565 28.5 25.137 27.7625 26.4497 26.4497C27.7625 25.137 28.5 23.3565 28.5 21.5V10.5C28.5 8.64348 27.7625 6.86301 26.4497 5.55025C25.137 4.2375 23.3565 3.5 21.5 3.5ZM16 22C14.8133 22 13.6533 21.6481 12.6666 20.9888C11.6799 20.3295 10.9108 19.3925 10.4567 18.2961C10.0026 17.1997 9.88378 15.9933 10.1153 14.8295C10.3468 13.6656 10.9182 12.5965 11.7574 11.7574C12.5965 10.9182 13.6656 10.3468 14.8295 10.1153C15.9933 9.88378 17.1997 10.0026 18.2961 10.4567C19.3925 10.9108 20.3295 11.6799 20.9888 12.6666C21.6481 13.6533 22 14.8133 22 16C22 17.5913 21.3679 19.1174 20.2426 20.2426C19.1174 21.3679 17.5913 22 16 22ZM22.5 11C22.2033 11 21.9133 10.912 21.6666 10.7472C21.42 10.5824 21.2277 10.3481 21.1142 10.074C21.0007 9.79994 20.9709 9.49834 21.0288 9.20736C21.0867 8.91639 21.2296 8.64912 21.4393 8.43934C21.6491 8.22956 21.9164 8.0867 22.2074 8.02882C22.4983 7.97094 22.7999 8.00065 23.074 8.11418C23.3481 8.22771 23.5824 8.41997 23.7472 8.66665C23.912 8.91332 24 9.20333 24 9.5C24 9.89782 23.842 10.2794 23.5607 10.5607C23.2794 10.842 22.8978 11 22.5 11Z"
            fill="white"
        />
    </svg>
);

export const FacebookIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.588 13.856L28.714 2H26.314L17.524 12.294L10.5 2H2.40002L13.02 17.568L2.40002 30H4.80002L14.084 19.128L21.502 30H29.602L18.588 13.856ZM15.302 17.704L14.226 16.154L5.66402 3.82H9.35003L16.258 13.774L17.334 15.324L26.316 28.264H22.63L15.302 17.704Z"
            fill="white"
        />
    </svg>
);

export const TwitterIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.588 13.856L28.714 2H26.314L17.524 12.294L10.5 2H2.40002L13.02 17.568L2.40002 30H4.80002L14.084 19.128L21.502 30H29.602L18.588 13.856ZM15.302 17.704L14.226 16.154L5.66402 3.82H9.35003L16.258 13.774L17.334 15.324L26.316 28.264H22.63L15.302 17.704Z"
            fill="white"
        />
    </svg>
);

export const LinkedInIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.572 11.9587H17.524V14.4254C18.2373 13.0067 20.0666 11.732 22.8146 11.732C28.0826 11.732 29.3333 14.556 29.3333 19.7374V29.3334H24V20.9174C24 17.9667 23.2866 16.3027 21.4706 16.3027C18.952 16.3027 17.9053 18.096 17.9053 20.916V29.3334H12.572V11.9587ZM3.42663 29.1067H8.75996V11.732H3.42663V29.1067ZM9.52396 6.06669C9.52416 6.51372 9.4355 6.95633 9.26314 7.3688C9.09078 7.78127 8.83816 8.15537 8.51996 8.46935C7.87516 9.11019 7.00237 9.46889 6.09329 9.46669C5.18581 9.46608 4.31504 9.10829 3.66929 8.47069C3.35224 8.15564 3.10047 7.78112 2.92842 7.3686C2.75636 6.95607 2.6674 6.51365 2.66663 6.06669C2.66663 5.16402 3.02663 4.30002 3.67063 3.66269C4.31581 3.02423 5.18695 2.66629 6.09463 2.66669C7.00396 2.66669 7.87596 3.02535 8.51996 3.66269C9.16263 4.30002 9.52396 5.16402 9.52396 6.06669Z"
            fill="white"
        />
    </svg>
);

export const SendIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.16665 5.26667L13.2417 2.90833C16.4167 1.85 18.1417 3.58333 17.0917 6.75833L14.7333 13.8333C13.15 18.5917 10.55 18.5917 8.96665 13.8333L8.26665 11.7333L6.16665 11.0333C1.40832 9.45 1.40832 6.85833 6.16665 5.26667Z"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.42499 11.375L11.4083 8.38333"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const EditIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.05 2.99999L4.20835 10.2417C3.95002 10.5167 3.70002 11.0583 3.65002 11.4333L3.34169 14.1333C3.23335 15.1083 3.93335 15.775 4.90002 15.6083L7.58335 15.15C7.95835 15.0833 8.48335 14.8083 8.74168 14.525L15.5834 7.28332C16.7667 6.03332 17.3 4.60832 15.4583 2.86665C13.625 1.14165 12.2334 1.74999 11.05 2.99999Z"
            stroke="#475569"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.90833 4.20834C10.2667 6.50834 12.1333 8.26668 14.45 8.50001"
            stroke="#475569"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.5 18.3333H17.5"
            stroke="#475569"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CopyIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 12.9V17.1C16 20.6 14.6 22 11.1 22H6.9C3.4 22 2 20.6 2 17.1V12.9C2 9.4 3.4 8 6.9 8H11.1C14.6 8 16 9.4 16 12.9Z"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22 6.9V11.1C22 14.6 20.6 16 17.1 16H16V12.9C16 9.4 14.6 8 11.1 8H8V6.9C8 3.4 9.4 2 12.9 2H17.1C20.6 2 22 3.4 22 6.9Z"
            stroke="#292D32"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const EyeIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.41998 12 8.41998C13.98 8.41998 15.58 10.02 15.58 12Z"
            stroke="#475569"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z"
            stroke="#475569"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const DownloadIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.44 8.90002C20.04 9.21002 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24002 7.46998 8.91002"
            stroke="#475569"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12 2V14.88" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.35 12.65L12 16L8.65002 12.65"
            stroke="#475569"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const EmailIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.1667 17.0833H5.83333C3.33333 17.0833 1.66667 15.8333 1.66667 12.9167V7.08332C1.66667 4.16666 3.33333 2.91666 5.83333 2.91666H14.1667C16.6667 2.91666 18.3333 4.16666 18.3333 7.08332V12.9167C18.3333 15.8333 16.6667 17.0833 14.1667 17.0833Z"
            stroke="#94A3B8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.1667 7.5L11.5583 9.58333C10.7 10.2667 9.29166 10.2667 8.43333 9.58333L5.83333 7.5"
            stroke="#94A3B8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const PasswordIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 8.33332V6.66666C5 3.90832 5.83333 1.66666 10 1.66666C14.1667 1.66666 15 3.90832 15 6.66666V8.33332"
            stroke="#94A3B8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 15.4167C11.1506 15.4167 12.0833 14.4839 12.0833 13.3333C12.0833 12.1827 11.1506 11.25 10 11.25C8.84941 11.25 7.91667 12.1827 7.91667 13.3333C7.91667 14.4839 8.84941 15.4167 10 15.4167Z"
            stroke="#94A3B8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.1667 18.3333H5.83333C2.5 18.3333 1.66667 17.5 1.66667 14.1667V12.5C1.66667 9.16668 2.5 8.33334 5.83333 8.33334H14.1667C17.5 8.33334 18.3333 9.16668 18.3333 12.5V14.1667C18.3333 17.5 17.5 18.3333 14.1667 18.3333Z"
            stroke="#94A3B8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
